export default {
  title: {
    id: 'gift_cards_title',
    defaultMessage: 'Customize your digital gift card',
  },
  subtitle: {
    id: 'gift_cards_subtitle',
    defaultMessage: 'Stress-free gifting that’s better for the planet.',
  },
  termsAndConditions: {
    id: 'gift_cards_terms_and_conditions',
    defaultMessage:
      'Limitations on gift card use include (a) they can’t be used with other discounts or paired with another gift card. (b) they can’t be used to purchase another gift card (c) any unused amount after the expiration date will be forfeited (d) only one gift card may be purchased at a time. {termsAndConditionsLink, html}',
  },
  termsAndConditionsLinkLabel: {
    id: 'gift_cards_terms_and_conditions_link_label',
    defaultMessage: 'See more Terms and conditions.',
  },
  termsAndConditionsLink: {
    id: 'gift_cards_terms_and_conditions_link',
    defaultMessage: 'https://www.backmarket.com/fr-fr/terms-and-conditions',
  },
  checkout: {
    id: 'gift_cards_checkout_button',
    defaultMessage: 'Checkout',
  },
  recipientNameRequired: {
    id: 'gift_cards_recipient_name_required',
    defaultMessage: "Don't forget your recipient's name",
  },
  senderNameRequired: {
    id: 'gift_cards_sender_name_required',
    defaultMessage: "Don't forget the sender's name",
  },
  messageMaxLength: {
    id: 'gift_cards_message_max_length',
    defaultMessage: 'The message must be less than {characterLimit} characters',
  },
  customAmountError: {
    id: 'gift_cards_custom_amount_error',
    defaultMessage: 'Enter an amount between {minPrice} - {maxPrice}.',
  },
}
